import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import {
  fetchBuilderBlockMetadata,
  getBuilderBlockMetadata,
  getBuilderBlockMetadataStatus,
} from 'redux/BuilderModeSlice';

import type { BuilderBlockMetadataResponse } from 'types/builderBlockMetadata';

const EMPTY_INDICATORS: BuilderBlockMetadataResponse['indicators'] = [];

export default function useBuilderPropertyMetadataSource(
  blockId: string | undefined,
  scenarioId: number | undefined,
) {
  const dispatch = useDispatch<any>();

  const { blockMetadata, blockMetadataStatus } = useSelector(
    (state: any) => ({
      blockMetadata: getBuilderBlockMetadata(state),
      blockMetadataStatus: getBuilderBlockMetadataStatus(state),
    }),
    shallowEqual,
  );

  const refetch = useCallback(() => {
    if (blockId && scenarioId) {
      dispatch(
        fetchBuilderBlockMetadata({
          blockId: Number(blockId),
          parameters: { scenario_id: scenarioId },
        }),
      );
    }
  }, [blockId, scenarioId, dispatch]);

  useEffect(() => {
    if (blockId && scenarioId) {
      dispatch(
        fetchBuilderBlockMetadata({
          blockId: Number(blockId),
          parameters: { scenario_id: scenarioId },
        }),
      );
    }
  }, [blockId, scenarioId, dispatch]);

  const metadataIndicators = useMemo(
    () => blockMetadata?.indicators ?? EMPTY_INDICATORS,
    [blockMetadata],
  );

  return {
    blockMetadata,
    blockMetadataStatus,
    metadataIndicators,
    refetch,
  };
}
